var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43516 8.19999C4.23516 13 0.535156 21.9 5.53516 26.9C8.73516 30.1 14.0352 30.1 17.2352 26.9C20.4352 23.6 20.4352 18.3 17.1352 15.2C15.5352 13.6 13.5352 13 11.5352 12.8C9.93516 12.6 11.2352 6.1 16.9352 1.7L15.8352 0.299995C11.2352 2.8 8.83516 6 7.43516 8.19999ZM32.4352 8.19999C29.2352 13 25.5352 21.9 30.5352 26.9C33.7352 30.1 39.0352 30.1 42.2352 26.9C45.4352 23.6 45.4352 18.3 42.1352 15.2C40.5352 13.6 38.5352 13 36.5352 12.8C34.9352 12.6 36.2352 6.1 41.9352 1.7L40.8352 0.299995C36.2352 2.8 33.8352 6 32.4352 8.19999Z",
    fill: "#1EA74A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.eb08ae0195290bf0136da955de347aed.svg";
export { ForwardRef as ReactComponent };